import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';

export default styled(animated.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  background-color: ${COLORS.black}b3;
  height: 100vh;
  width: 100%;
  z-index: ${({ zindex }: { zindex: number }) => zindex || 1};
  overflow-y: hidden;
`;
